import React from 'react';
import getContent from '../lib/dictionaryFetcher';

class FeedbackComplete extends React.Component {
  constructor() {
    super();
    this.state = {
      shouldShowComp: true
    };
  }

  feedbackCompleteClose = () => {
    this.setState({ shouldShowComp: false });
  };

  render() {
    const { shouldShowComp } = this.state;
    return (
      <React.Fragment>
        {shouldShowComp && (
          <div className="feedback-complete-container">
            <div className="feedback-complete-container-text">
              <span className="ppvx_icon ppvx_icon--size_sm ppvx_icon-check feedback-complete-icon" />
              <p className="feedback-complete-text">
                {getContent('quiz', 'feedback.complete')}
              </p>
            </div>
            <button
              onClick={this.feedbackCompleteClose}
              className="feedback-complete-button-close"
            >
              <span className="ppvx_icon ppvx_icon--size_sm ppvx_icon-close feedback-complete-close" />
            </button>
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default FeedbackComplete;
